import { connect } from 'react-redux';
import { Upload } from './Upload';
import { getSOA3UploadUrl } from 'src/redux/cases/casesSelectors';
var mapStateToProps = function (state) { return ({
    soa3UploadUrl: getSOA3UploadUrl(state),
}); };
var mapDispatchToProps = function (dispatch) { return ({}); };
export default connect(mapStateToProps, mapDispatchToProps)(Upload);
